<template>
  <div class="d-flex flex-column align-center justify-center h-100 my-8">
    <slot name="illustration"></slot>
    <h3 class="title font-weight-regular mt-8">
      {{ $t(message) }}
    </h3>
    <div class="mt-3 grey--text text--darken-1">{{ $t(description) }}</div>
    <div class="mt-5"><slot name="content"></slot></div>
  </div>
</template>
<script>
export default {
  name: 'base-empty-state',
  props: {
    message: {
      type: String
    },
    description: {
      type: String
    }
  }
}
</script>
